var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmotionsSad = function SvgEmotionsSad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#emotions-sad_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.333 7.5A1.667 1.667 0 1 1 5 7.5a1.667 1.667 0 0 1 3.333 0M15 7.5a1.667 1.667 0 1 1-3.333 0A1.667 1.667 0 0 1 15 7.5m-8.614 6.26a.75.75 0 1 0 1.3.747 2.666 2.666 0 0 1 4.626-.002.75.75 0 1 0 1.301-.747 4.167 4.167 0 0 0-7.227.003",
    clipRule: "evenodd",
    opacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "emotions-sad_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 2.708 7.292)scale(15.4167)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#65b3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#256bf2"
  })))));
};
export default SvgEmotionsSad;